import { useContext } from "react";

import { DupFlowContext } from "../context/DupFlowContext";

export const useDupFlowContext = () => {
  const context = useContext(DupFlowContext);

  if (context === undefined) {
    throw new Error("'useDupContext' must be used within a 'DupFlowProvider'");
  }

  return context;
};
